import { isAdmin } from "@/services/auth.service";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/campaigns/$id/(edit)")({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (!isAdmin(context.user))
      throw redirect({
        from: Route.fullPath,
        to: "/campaigns/$id",
      });
  },
});

function RouteComponent() {
  return (
    <div className="flex grow flex-col justify-center p-8 pt-4 xl:p-14 xl:pt-7">
      <Outlet />
    </div>
  );
}
